import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Alert, Button, Dialog, DialogTitle, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import API from "../../../../services/API";
import { useMutation, useQuery } from "react-query";
import Loader from "../../../Tools/Loader";

export default function InvoicesModal({session, onClose}){

    const [showForm, setShowForm] = useState(false);

    const {data: invoices, isLoading, isError, refetch} = useQuery({
        queryKey: ['dpc', 'sessions', session?.id, 'invoices'],
        queryFn: async () => {
            const response = await API.get(`/dpc/sessions/${session.id}/invoices`);
            return response.data;
        },
        enabled: !!session?.id,
    });

    const creation = useMutation({
        mutationFn: async body => {
            const response = await API.post(`/dpc/sessions/${session.id}/invoices`, body);
            return response.data;
        },
        onSuccess: () => {
            refetch();
            setShowForm(false);
        },
        onError: e => console.log(e),
    });

    const [downloadingId, setDownloadingId] = useState(null);

    const handleDownload = invoice => {

        setDownloadingId(invoice.id)

        const fileName = `Facture-${session?.action?.id}-${session?.number}-${invoice.number}.pdf`;

        API.download(`/dpc/invoices/${invoice.id}/invoice.pdf`, fileName)
            .catch(e => console.log(e))
            .finally(() => setDownloadingId(null))
    }

    const handleSubmit = e => {
        e.preventDefault();

        const ok = window.confirm('Voulez-vous vraiment ajouter cette facture partielle ? Cette opération est irréversible.');
        if(!ok) return false;

        const stringAmount = e.target.elements['amount'].value;
        const amount = parseFloat(stringAmount.replace(',', '.'));

        const body = { amount, type: 'PARTIAL' };

        creation.mutate(body);
    }

    const handleClose = () => {
        setShowForm(false);
        onClose();
    }

    return (
        <Dialog onClose={handleClose} open={session ? true : false}>

            <DialogTitle>Session {session?.number} - Factures</DialogTitle>

            <Stack sx={{minWidth: 300}}>

                {isLoading && <Loader />}

                {isError && <Alert severity="error">Erreur lors de la récupération des factures</Alert>}

                {invoices?.map(invoice => 
                    <Stack 
                        key={invoice.id} 
                        direction="row" 
                        spacing={2} 
                        alignItems="center"
                        onClick={() => handleDownload(invoice)}
                        sx={{p: 1}}
                    >

                        <LoadingButton
                            loading={downloadingId === invoice.id}
                        >
                            <Download />
                        </LoadingButton>
                            
                        <Typography color="text.secondary" variant="body2">
                            Facture {invoice.number}
                        </Typography>

                    </Stack>    
                )}

            </Stack>

            {!showForm &&
                <Button onClick={() => setShowForm(true)}>Ajouter une facture partielle</Button>
            }

            {showForm &&
                <Stack component="form" gap={2} onSubmit={handleSubmit} sx={{p: 2}}>
                    <Typography>Ajouter une facture partielle pour cette session</Typography>

                    <Alert severity="warning">
                        Attention : la création d'une facture a une valeur comptable.
                    </Alert>

                    <TextField 
                        label="Montant de la facture partielle" 
                        name="amount" 
                        type="number" 
                        required 
                        size="small" 
                        inputProps={{
                            step: '0.01',
                            min: '0',
                        }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">€</InputAdornment>,
                        }}
                    />
                    <Stack direction="row" justifyContent="flex-end" gap={2}>
                        <Button onClick={() => setShowForm(false)} variant="outlined">Annuler</Button>
                        <LoadingButton type="submit" variant="contained" loading={creation.isLoading}>Ajouter</LoadingButton>
                    </Stack>
                </Stack>
            }

        </Dialog>
    )
}
